// extracted by mini-css-extract-plugin
module.exports = {"label":"ServerSettings_label__1Qsd9","section":"ServerSettings_section__7nUiE","input":"ServerSettings_input__1WbQ4"};